import { render, staticRenderFns } from "./ModalPDVReservas.vue?vue&type=template&id=7b1baa6c&scoped=true&"
import script from "./ModalPDVReservas.vue?vue&type=script&lang=js&"
export * from "./ModalPDVReservas.vue?vue&type=script&lang=js&"
import style0 from "./ModalPDVReservas.vue?vue&type=style&index=0&id=7b1baa6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1baa6c",
  null
  
)

export default component.exports